
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 8.963c0 .251.103.503.307.69l5.487 5.074a1.05 1.05 0 001.413 0l5.485-5.073a.93.93 0 00.021-1.363 1.051 1.051 0 00-1.432-.018l-4.78 4.43-4.78-4.43a1.051 1.051 0 00-1.433.018.933.933 0 00-.288.672z","fill":"#999392"}})])
          )
        }
      }
    